import { GameConstants } from "../../GameConstants";
import { GameVars } from "../../GameVars";
import { EventType, MessagePosition } from "../../Types";
import { TutorialManager } from "../tutorial-scene/TutorialManager";

export class MessagesLayer extends Phaser.GameObjects.Container {

    constructor(scene: Phaser.Scene, msg: string, position?: MessagePosition, delay?: number, requiredAction?: EventType) {
        
        super(scene);

        const lan = GameVars.gameData.language;
        const text = GameVars.currentScene.cache.json.get("text");

        position = position || MessagePosition.TOP;
        delay = delay || 0;

        this.x = GameConstants.GAME_WIDTH / 2;
        this.y = GameConstants.GAME_HEIGHT / 2;
        this.scaleY = GameVars.scaleY;

        let scaleWrapConfig = [
            { maxLen: 90,  scaleX: 1.15, wrapWidth: 370 },
            { maxLen: 120, scaleX: 1.25, wrapWidth: 420 },
            { maxLen: 150, scaleX: 1.35, wrapWidth: 440 },
            { maxLen: 170, scaleX: 1.5,  wrapWidth: 460 },
            { maxLen: Infinity, scaleX: 1.65, wrapWidth: 500 } // Default case
        ];
        
        let config = scaleWrapConfig.find(config => msg.length < config.maxLen);
        let { scaleX, wrapWidth } = config;

        let y: number;

        switch (position) {

            case MessagePosition.TOP:
                y = -290; // era -290
                break;

            case MessagePosition.MIDDLE:
                y = -105;
                break;

            case MessagePosition.BOTTOM:
                y = 405;
                break;

            default:
        }

        const background = new Phaser.GameObjects.Image(scene, 0, y, "texture_atlas_1", "card_description_background");
        background.setScale(scaleX, 1.1 * scaleX);
        this.add(background);

        const descriptionLabel = new Phaser.GameObjects.Text(scene, 0, background.y - 5, msg, {fontFamily: "Oswald_ExtraLight", fontSize: 28, color: "#5f2a01", align: "center"});
        descriptionLabel.setOrigin(.5);
        descriptionLabel.setWordWrapWidth(wrapWidth);
        this.add(descriptionLabel);

        if (GameVars.tutorialMode && !TutorialManager.showingSpecialCardDescription) {

            const avatar = new Phaser.GameObjects.Image(scene, background.x - background.width / 2 * scaleX * .92, background.y - background.height / 2 * scaleX * .9, "texture_atlas_1", "avatar");
            this.add(avatar);

            if (requiredAction && requiredAction === EventType.CLICK) {

                const str = this.scene.game.device.os.desktop ? text.CLICK_CONTINUE[lan] : text.TAP_CONTINUE[lan];

                const py = position === MessagePosition.BOTTOM ? 245 : 360;

                const actionLabel = new Phaser.GameObjects.Text(scene, 0, py, str, {fontFamily: "AlmendraBold", color: "#FFFFFF", fontSize: "46px"});
                actionLabel.setOrigin(.5);
                this.add(actionLabel);

                actionLabel.alpha = 0;

                this.scene.tweens.add({
                    targets: actionLabel,
                    alpha: 1,
                    duration: 450,
                    delay: delay + 750,
                    ease: Phaser.Math.Easing.Cubic.Out,
                    onComplete: () => {

                        this.scene?.tweens.add({
                            targets: actionLabel,
                            alpha: .65,
                            duration: 450,
                            ease: Phaser.Math.Easing.Cubic.Out,
                            yoyo: true,
                            repeat: -1
                        });
                    },
                    onCompleteScope: this   
                });
            }
        }

        this.alpha = 0;

        this.scene.tweens.add({
            targets: this,
            alpha: 1,
            duration: 500,
            delay: delay,
            ease: Phaser.Math.Easing.Quintic.In
        });
    }
}
